import { CSSProperties, useState } from 'react';

import { NotFound404 } from '@backrs_ui/common-ui';

import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';

import { Box, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

type EmbeddedSiteName = 'majors' | 'success-system';

const EMBEDDED_SITE_URLS: Record<EmbeddedSiteName, string> = {
  majors: 'https://majors.backrs.com',
  'success-system': 'https://successsystem.backrs.com',
  // we may add more loveable prototypes here
};

type EmbeddedSitePageProps = Readonly<{
  type: EmbeddedSiteName;
}>;

export const EmbeddedSitePage = ({ type }: EmbeddedSitePageProps) => {
  const url = EMBEDDED_SITE_URLS[type];
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return <NotFound404 />;
  }

  return (
    <Box sx={containerSx}>
      {isLoading && (
        <Box sx={loadingSx}>
          <Lottie animationData={lottieAnimations.dotsDotting} />
        </Box>
      )}
      <iframe
        src={url}
        title={`${type} prototype`}
        style={iframeSx}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setHasError(true);
        }}
      />
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  width: '100%',
  flexGrow: 1,
  alignSelf: 'stretch',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
};

const loadingSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: backrs.colors['Beige/25'],
});

const iframeSx: CSSProperties = {
  border: 'none',
  width: '100%',
  flex: 1,
  minHeight: 0,
};
